export default __webpack_public_path__ + "static/media/check-circle.9002da34.svg";